import React from 'react';
import PropTypes from 'prop-types';
import Idea from '../../Components/Idea';
import { Button } from '@salesforce/design-system-react';

const PotentialConnectors = (props) => {
  return (
    <React.Fragment>
      <div className="slds-wrap slds-gutters slds-p-horizontal_xx-large">
        <div key="milestone-idea-button">
          <p className="grey-font slds-text-heading_medium page-block-header-title slds-align_absolute-center">Create A Potential Connector</p>
          <Button
            variant="brand"
            onClick={props.onButtonClick}
            className="slds-m-top_small slds-align_absolute-center add-idea-button"
          />
          
        </div>
        {Object.keys(props.ideas).map((ideaId) => {
          let idea = props.ideas[ideaId];
          return (
            <div key={idea.id} className="slds-p-top_x-small slds-p-horizontal_xx-small" style={{ width: '33%', display: 'inline-block'}}>
              <Idea
                heading=""
                personaId={idea.personaId}
                milestone={props.currentMilestone}
                connectors={true}
                chosen={idea.chosen}
                ideaContent={idea.ideaContent}
                id={idea.id}
                key={idea.id}
                onDropdownSelected={props.onDropdownSelected}
                openEditIdea={props.openEditIdea}
              />
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

PotentialConnectors.propTypes = {
  ideas: PropTypes.object.isRequired,
  currentMilestone: PropTypes.string.isRequired,
  onDropdownSelected: PropTypes.func.isRequired,
};

export default PotentialConnectors;
